import React, { useEffect, useState } from "react";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { MdDelete, MdEdit } from "react-icons/md";
import { getPlacementProcessDetailsapi } from "Services/allApi";
import { addPlacementProcessApi } from "Services/allApi";
import { editPlacementProcessPage } from "Services/allApi";
import { deletePlacementProcessApi } from "Services/allApi";

const PlacementProcess = () => {
 const [placementProcess, setplacementProcess] = useState([]);
         const [isEditModalOpen, setIsEditModalOpen] = useState(false);
         const [isModalOpen, setIsModalOpen] = useState(false);
         const [selecteddescription, setSelecteddescription] = useState(null);
         const [loading, setLoading] = useState(true);
         const [index, setIndex] = useState("");
         const [title, settitle] = useState("");
         const [description, setdescription] = useState("");
         const [editIndex, setEditIndex] = useState("");
         const [edittitle, setEdittitle] = useState("");
         const [editdescription, setEditdescription] = useState("");
     
         const openModal = () => setIsModalOpen(true);
         const closeModal = () => {
             setIsModalOpen(false);
             setIndex("");
             settitle("");
             setdescription("");
 
         };
     
         const openEditModal = (description) => {
             setSelecteddescription(description);
             setEditIndex(description.index || "");
             setEdittitle(description.title || "");
             setEditdescription(description.description || "");
             setIsEditModalOpen(true);
         };
     
         const closeEditModal = () => {
             setIsEditModalOpen(false);
             setSelecteddescription(null);
         };
     
         const fetchplacementProcess = async () => {
             try {
                 setLoading(true);
                 const response = await getPlacementProcessDetailsapi();
                 if (response?.status === 200 && response.data) {
                     setplacementProcess(response.data);
                 } else {
                     toast.error('Failed to fetch data');
                     setplacementProcess([]);
                 }
             } catch (error) {
                 console.error("Error fetching placement descriptions:", error);
                 toast.error('Error fetching data');
                 setplacementProcess([]);
             } finally {
                 setLoading(false);
             }
         };
     
         const handleSave = async () => {
             if (!title.trim() || !description.trim()  || !index.trim()) {
                 toast.error("title and description are required!");
                 return;
             }
     
             const newdescriptionData = { index, title, description };
     
             try {
                 const response = await addPlacementProcessApi(newdescriptionData);
                 if (response?.status === 200) {
                     toast.success("Placement description added successfully!");
                     closeModal();
                     fetchplacementProcess();
                 } else {
                     toast.error("Failed to add placement description.");
                 }
             } catch (error) {
                 console.error("Error adding placement description:", error);
                 toast.error("Error adding data.");
             }
         };
     
         const handleEditSave = async () => {
             if (!selecteddescription) return;
         
             const updatedData = { index: editIndex, title: edittitle, description: editdescription };
         
             try {
                 const response = await editPlacementProcessPage(selecteddescription.id, updatedData);
                 if (response?.status === 200) {
                     toast.success("Placement description updated successfully!");
                     closeEditModal();
                     fetchplacementProcess();
                 } else {
                     toast.error("Failed to update placement description.");
                 }
             } catch (error) {
                 console.error("Error updating placement description:", error);
                 toast.error("Error updating data.");
             }
         };
     
         const handleDeletedescription = async (id) => {
             try {
                 const response = await deletePlacementProcessApi(id);
                 if (response?.status === 204) {
                     toast.success("Placement description deleted successfully!");
                     fetchplacementProcess();
                 } else {
                     toast.error("Failed to delete placement description.");
                 }
             } catch (error) {
                 console.error("Error deleting placement description:", error);
                 toast.error("Error deleting data.");
             }
         };
     
         useEffect(() => {
             fetchplacementProcess();
         }, []);
   return (
      <>
                             <h2 className="mt-5 text-xl font-bold text-center mb-4">Placement Process</h2>
     
                             {loading ? (
                                 <div className="text-center py-4 text-purple-500">Loading...</div>
                             ) : (
                                 <>
                                     <button
                                         className="rounded-lg px-7 py-2 text-white bg-green-700 font-large text-large transition duration-200 hover:bg-green-800 float-end"
                                         onClick={openModal}
                                         aria-label="Add Placement description"
                                     >
                                         Add +
                                     </button>
     
                                     {/* Add Modal */}
                                     {isModalOpen && (
                                         <div className="fixed inset-0 flex items-center justify-center bg-gray-500 bg-opacity-50">
                                             <div className="bg-white p-6 rounded-lg w-[600px]">
                                                 <h2 className="text-lg font-bold mb-4">Add Placement description</h2>
 
                                                 <input
                                                     type="text"
                                                     className="w-full border p-2 mb-2"
                                                     placeholder="index"
                                                     value={index}
                                                     onChange={(e) => setIndex(e.target.value)}
                                                 />
                                                 <input
                                                     type="text"
                                                     className="w-full border p-2 mb-2"
                                                     placeholder="title"
                                                     value={title}
                                                     onChange={(e) => settitle(e.target.value)}
                                                 />
                                                 <input
                                                     type="text"
                                                     className="w-full border p-2 mb-2"
                                                     placeholder="description"
                                                     value={description}
                                                     onChange={(e) => setdescription(e.target.value)}
                                                 />
                                                
                                                 <div className="flex justify-end space-x-2">
                                                     <button className="px-4 py-2 bg-gray-300 rounded-lg" onClick={closeModal}>Cancel</button>
                                                     <button className="px-4 py-2 bg-blue-500 text-white rounded-lg" onClick={handleSave}>Save</button>
                                                 </div>
                                             </div>
                                         </div>
                                     )}
     
                                     <br /> <br />
     
                                     <div className="overflow-x-auto">
                                         <table className="table-auto w-full">
                                             <thead>
                                                 <tr className="bg-gray-100 text-left dark:bg-gray-800 dark:text-white">
                                                 <th className="px-4 py-2">Index</th>
                                                     <th className="px-4 py-2">title</th>
                                                     <th className="px-4 py-2">description</th>
                                                     <th className="px-4 py-2 text-center">Edit</th>
                                                     <th className="px-4 py-2 text-center">Delete</th>
                                                 </tr>
                                             </thead>
                                             <tbody>
                                                 {placementProcess.length > 0 ? (
                                                     placementProcess.map((description) => (
                                                         <tr key={description.id} className="hover:bg-gray-50 dark:hover:bg-gray-800">
                                                             <td className="px-4 py-2">{description.index || "N/A"}</td>
                                                             <td className="px-4 py-2">{description.title || "N/A"}</td>
                                                             <td className="px-4 py-2">{description.description || "N/A"}</td>
                                                             <td className="px-4 py-2 text-center">
                                                                 <button
                                                                     className="rounded-lg px-4 py-2 text-green-700 transition duration-200 hover:bg-white-700"
                                                                     onClick={() => openEditModal(description)}
                                                                     aria-label="Edit"
                                                                 >
                                                                     <MdEdit className='text-green-700 text-2xl' />
                                                                 </button>
                                                             </td>
                                                             <td className="px-4 py-2 text-center">
                                                                 <button
                                                                     className="ml-4"
                                                                     onClick={() => handleDeletedescription(description.id)}
                                                                     aria-label="Delete"
                                                                 >
                                                                     <MdDelete className='text-red-700 text-2xl' />
                                                                 </button>
                                                             </td>
                                                         </tr>
                                                     ))
                                                 ) : (
                                                     <tr>
                                                         <td colSpan="4" className="px-4 py-2 text-center text-red-500">
                                                             No placement descriptions found.
                                                         </td>
                                                     </tr>
                                                 )}
                                             </tbody>
                                         </table>
                                     </div>
                                 </>
                             )}
     
                             {/* Edit Modal */}
                             {isEditModalOpen && (
                                 <div className="fixed inset-0 flex items-center justify-center bg-gray-500 bg-opacity-50">
                                     <div className="bg-white p-6 rounded-lg w-[600px]">
                                         <h2 className="text-lg font-bold mb-4">Edit Placement description</h2>
                                         {/* <input
                                             type="text"
                                             className="w-full border p-2 mb-2"
                                             value={index}
                                             onChange={(e) => setEditIndex(e.target.value)}
                                         /> */}
                                         <input
                                             type="text"
                                             className="w-full border p-2 mb-2"
                                             value={edittitle}
                                             onChange={(e) => setEdittitle(e.target.value)}
                                         />
                                         <input
                                             type="text"
                                             className="w-full border p-2 mb-2"
                                             value={editdescription}
                                             onChange={(e) => setEditdescription(e.target.value)}
                                         />
                                         <div className="flex justify-end space-x-2">
                                             <button className="px-4 py-2 bg-gray-300 rounded-lg" onClick={closeEditModal}>Cancel</button>
                                             <button className="px-4 py-2 bg-blue-500 text-white rounded-lg" onClick={handleEditSave}>Save</button>
                                         </div>
                                     </div>
                                 </div>
                             )}
                         </>
   )
 }

export default PlacementProcess